"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointLight = void 0;
const gl_matrix_1 = require("gl-matrix");
const ILight_1 = require("../../interface/ILight");
const AbstractLight_1 = require("../AbstractLight");
class PointLight extends AbstractLight_1.AbstractLight {
    // #endregion Properties (3)
    // #region Constructors (1)
    constructor(properties) {
        super({
            color: properties.color || '#ffffff',
            intensity: properties.intensity !== undefined ? properties.intensity : 0.5,
            type: ILight_1.LIGHTTYPE.POINT,
            name: properties.name,
            order: properties.order,
            id: properties.id
        });
        // #region Properties (3)
        this._decay = 2;
        this._distance = 0;
        this._position = gl_matrix_1.vec3.fromValues(0, 0, 0);
        if (properties.position)
            this._position = properties.position;
        if (properties.distance)
            this._distance = properties.distance;
        if (properties.decay)
            this._decay = properties.decay;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (6)
    get decay() {
        return this._decay;
    }
    set decay(value) {
        this._decay = value;
        this.updateVersion();
    }
    get distance() {
        return this._distance;
    }
    set distance(value) {
        this._distance = value;
        this.updateVersion();
    }
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
        this.updateVersion();
    }
    // #endregion Public Accessors (6)
    // #region Public Methods (1)
    clone() {
        return new PointLight({
            color: this.color,
            position: this.position,
            distance: this.distance,
            decay: this.decay,
            intensity: this.intensity,
            name: this.name,
            order: this.order
        });
    }
}
exports.PointLight = PointLight;
//# sourceMappingURL=PointLight.js.map